// extracted by mini-css-extract-plugin
export default {"faqs":"Aq-z","faqContent":"Bq-z","faq":"Cq-z"};